import * as Mod1 from "./discourse/api-initializers/post-voting-reviewables";
import * as Mod2 from "./discourse/components/post-voting-answer-button";
import * as Mod3 from "./discourse/components/post-voting-answer-header";
import * as Mod4 from "./discourse/components/post-voting-button";
import * as Mod5 from "./discourse/components/post-voting-comment-actions";
import * as Mod6 from "./discourse/components/post-voting-comment-composer";
import * as Mod7 from "./discourse/components/post-voting-comment-editor";
import * as Mod8 from "./discourse/components/post-voting-comment";
import * as Mod9 from "./discourse/components/post-voting-comments-menu-composer";
import * as Mod10 from "./discourse/components/post-voting-comments-menu";
import * as Mod11 from "./discourse/components/post-voting-comments";
import * as Mod12 from "./discourse/components/post-voting-vote-controls";
import * as Mod13 from "./discourse/components/post-voting-who-voted-list";
import * as Mod14 from "./discourse/components/reviewable/post-voting-comment";
import * as Mod15 from "./discourse/connectors/category-custom-settings/post-voting-category-settings.gjs";
import * as Mod16 from "./discourse/connectors/topic-above-post-stream/add-post-voting-topic-page-class.gjs";
import * as Mod17 from "./discourse/initializers/custom-post-message-callbacks";
import * as Mod18 from "./discourse/initializers/extend-composer-actions";
import * as Mod19 from "./discourse/initializers/post-voting-admin-plugin-configuration-nav";
import * as Mod20 from "./discourse/initializers/post-voting-edits";
import * as Mod21 from "./discourse/initializers/post-voting-icon";
import * as Mod22 from "./discourse/lib/post-voting-flag";
import * as Mod23 from "./discourse/lib/post-voting-utilities";
const compatModules = {
  "discourse/api-initializers/post-voting-reviewables": Mod1,
  "discourse/components/post-voting-answer-button": Mod2,
  "discourse/components/post-voting-answer-header": Mod3,
  "discourse/components/post-voting-button": Mod4,
  "discourse/components/post-voting-comment-actions": Mod5,
  "discourse/components/post-voting-comment-composer": Mod6,
  "discourse/components/post-voting-comment-editor": Mod7,
  "discourse/components/post-voting-comment": Mod8,
  "discourse/components/post-voting-comments-menu-composer": Mod9,
  "discourse/components/post-voting-comments-menu": Mod10,
  "discourse/components/post-voting-comments": Mod11,
  "discourse/components/post-voting-vote-controls": Mod12,
  "discourse/components/post-voting-who-voted-list": Mod13,
  "discourse/components/reviewable/post-voting-comment": Mod14,
  "discourse/connectors/category-custom-settings/post-voting-category-settings": Mod15,
  "discourse/connectors/topic-above-post-stream/add-post-voting-topic-page-class": Mod16,
  "discourse/initializers/custom-post-message-callbacks": Mod17,
  "discourse/initializers/extend-composer-actions": Mod18,
  "discourse/initializers/post-voting-admin-plugin-configuration-nav": Mod19,
  "discourse/initializers/post-voting-edits": Mod20,
  "discourse/initializers/post-voting-icon": Mod21,
  "discourse/lib/post-voting-flag": Mod22,
  "discourse/lib/post-voting-utilities": Mod23,
};
export default compatModules;
